import { notification } from 'antd';
import dayjs from 'dayjs';
import MessagesTypes from '../action-types/messages';
import { TAB_NOTES_MODE } from 'components/organisms/ListingViewMessageCenter/TabNotes';
import { sortNotes } from 'components/organisms/ListingViewMessageCenter/TabNotes/getNotesFromListing';

const initialState = {
  data: null,
  error: null,
  loading: true,
  tab: '1',
  mode: 'list',

  notes: [],
  tabNotesMode: TAB_NOTES_MODE.LIST,
  notesTabIsLoading: false,
};

const createMessageSuccess = (state) => {
  notification['success']({
    message: 'Message sent',
  });

  return {
    ...state,
    loading: true,
  };
};

const createMessageRequest = (state) => {
  return { ...state, loading: true };
};

const createMessageError = (state, { error }) => {
  return { ...state, error, loading: false };
};

const setTabLoading = (state) => {
  return { ...state, loading: true };
};

const addBreederMessage = (state, { message }) => {
  const messages = [message, ...state.data.messages];
  return {
    ...state,
    loading: false,
    data: {
      ...state.data,
      messages,
    },
  };
};

const fetchMessagesSuccess = (state, { data }) => {
  let { messages, users } = data;
  // User's ID hash table.
  users = users.reduce((previousValue, currentValue) => {
    previousValue[currentValue.id] = currentValue;
    return previousValue;
  }, {});

  // Add user name to each message.
  messages = messages.map((message) => ({
    ...message,
    author: `${users[message.authorId].firstName} ${
      users[message.authorId].lastName
    }`,
  }));

  return {
    ...state,
    loading: false,
    data: {
      ...state.data,
      messages: messages.sort((a, b) =>
        dayjs(a.createdAt).isBefore(b.createdAt) ? 1 : -1
      ),
    },
  };
};

const fetchMessagesError = (state, { error }) => {
  return { ...state, error, loading: false };
};

const setTab = (state, { tab }) => {
  return { ...state, tab };
};

const setMode = (state, { mode }) => {
  return { ...state, mode };
};

const setTabNotes = (state, { notes }) => {
  return { ...state, notes };
};

const notesTabIsLoading = (state, { notesTabIsLoading }) => {
  return { ...state, notesTabIsLoading };
};

const setUpdateNote = (state, { newNote }) => {
  return {
    ...state,
    notes: state.notes.map((n) => {
      return n?.id === newNote?.id ? newNote : n;
    }),
  };
};

const addNewInternalNote = (state, { note }) => {
  return {
    ...state,
    notes: sortNotes([...state.notes, note]),
  };
};

const toggleTabNotesMode = (state) => {
  const tabNotesMode =
    state.tabNotesMode === TAB_NOTES_MODE.LIST
      ? TAB_NOTES_MODE.CREATE
      : TAB_NOTES_MODE.LIST;
  return {
    ...state,
    tabNotesMode,
  };
};

const messagesReducer = (state = initialState, action) => {
  switch (action.type) {
    case MessagesTypes.SET_MODE:
      return setMode(state, action);
    case MessagesTypes.SET_TAB:
      return setTab(state, action);
    case MessagesTypes.SET_TAB_LOADING:
      return setTabLoading(state);

    case MessagesTypes.CREATE_MESSAGE_REQUEST:
      return createMessageRequest(state);
    case MessagesTypes.CREATE_MESSAGE_SUCCESS:
      return createMessageSuccess(state);
    case MessagesTypes.CREATE_MESSAGE_ERROR:
      return createMessageError(state, action);

    case MessagesTypes.FETCH_MESSAGES_SUCCESS:
      return fetchMessagesSuccess(state, action);
    case MessagesTypes.FETCH_MESSAGES_ERROR:
      return fetchMessagesError(state, action);
    case MessagesTypes.ADD_BREEDER_MESSAGE:
      return addBreederMessage(state, action);

    case MessagesTypes.SET_TAB_NOTES:
      return setTabNotes(state, action);
    case MessagesTypes.NOTES_TAB_IS_LOADING:
      return notesTabIsLoading(state, action);
    case MessagesTypes.UPDATE_NOTE:
      return setUpdateNote(state, action);
    case MessagesTypes.ADD_NEW_INTERNAL_NOTE:
      return addNewInternalNote(state, action);
    case MessagesTypes.TOGGLE_TAB_NOTES_MODE:
      return toggleTabNotesMode(state);

    default:
      return state;
  }
};

export default messagesReducer;
